import { AuthGuard } from "./modules/shared/services/auth-guard.service";
import { LayoutComponent } from "./modules/shared/layout/layout.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { AuthlayoutComponent } from "./modules/shared/layout/authlayout/authlayout.component";
import { ErrorPageComponent } from "./modules/shared/error-page/error-page.component";

const routes: Routes = [
  
  {
    path: "sso",
    component: AuthlayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/sso-login/login.module").then((m) => m.LoginModule),
      },
    ],
  },
 
  {
    path: "video",
    // canActivate: [AuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/IoTCore/IOT.module").then((m) => m.IOTModule),
      },
    ],
  },
  {
    path: "share",
    canActivate: [AuthGuard],
    // component: LayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/IoTCore/IOT.module").then((m) => m.IOTModule),
      },
    ],
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./modules/IoTCore/IOT.module").then((m) => m.IOTModule),
      },
    ],
  },
  {
    path: "",
    component: LayoutComponent,
    children:[
      {
        path: 'error',
        component: ErrorPageComponent,
        data: {
          'type': 404,
          'title': 'Page Not Found',
          'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
        }
      },
    ]
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
